export default "__VITE_ASSET__D0E5u7Ts__"